import { Component, Input, SimpleChanges } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { TPVServices } from "../../../services";
import { ChangeDetectionStrategy } from "@angular/core";

/**
 * Generated class for the TpvTicketSelectedListTicketPrintPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    changeDetection: ChangeDetectionStrategy.Default, //Sin esto no detecta el cambio del total y da un error
    selector: 'page-tpv-ticket-selected-list-ticket-print-indv',
    templateUrl: 'tpv-ticket-selected-list-ticket-print-indv.html',
})
export class TpvTicketSelectedListTicketPrintIndvPage {
    @Input() selected_list: any;
    footer: any;
    header: any;
    list_tax: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public tpvServices: TPVServices) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.selected_list) {
            this.list_tax = this.globals.showIvaProducts(this.selected_list);
        }
    }

    calculateVariations(name, units, price, variation_add) {
        if (variation_add == undefined) {
            variation_add = 0;
        }
        return (parseFloat(units) * parseFloat(price)) + parseFloat(variation_add)
    }

}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-list-ticket-print-indv/tpv-ticket-selected-list-ticket-print-indv.ts